import Swal, { SweetAlertIcon } from 'sweetalert2';

export const showAlert = (title: string, text: string, icon: SweetAlertIcon) => {
    Swal.fire({
        title: title,
        text: text,
        icon: icon, // 'success', 'error', 'warning', 'info', or 'question'
        confirmButtonText: 'OK',
        confirmButtonColor: '#4277c2',
    });
};